const auth = '639dd5a0a149ddbd1be06e682808d16d65377c7b';

export default {
    state: {
        countries: [],
        states: [],
        cities: [],
        location: {},
        countryCode: '',
        validZIP: true,
        staticCountries: [
            { name: 'Afghanistan', code: 'AF' },
            { name: 'Albania', code: 'AL' },
            { name: 'Algeria', code: 'DZ' },
            { name: 'Andorra', code: 'AD' },
            { name: 'Angola', code: 'AO' },
            { name: 'Antigua and Barbuda', code: 'AG' },
            { name: 'Argentina', code: 'AR' },
            { name: 'Armenia', code: 'AM' },
            { name: 'Australia', code: 'AU' },
            { name: 'Austria', code: 'AT' },
            { name: 'Azerbaijan', code: 'AZ' },
            { name: 'Bahamas', code: 'BS' },
            { name: 'Bahrain', code: 'BH' },
            { name: 'Bangladesh', code: 'BD' },
            { name: 'Barbados', code: 'BB' },
            { name: 'Belarus', code: 'BY' },
            { name: 'Belgium', code: 'BE' },
            { name: 'Belize', code: 'BZ' },
            { name: 'Benin', code: 'BJ' },
            { name: 'Bhutan', code: 'BT' },
            { name: 'Bolivia', code: 'BO' },
            { name: 'Bosnia and Herzegovina', code: 'BA' },
            { name: 'Botswana', code: 'BW' },
            { name: 'Brazil', code: 'BR' },
            { name: 'Brunei', code: 'BN' },
            { name: 'Bulgaria', code: 'BG' },
            { name: 'Burkina Faso', code: 'BF' },
            { name: 'Burundi', code: 'BI' },
            { name: 'Cabo Verde', code: 'CV' },
            { name: 'Cambodia', code: 'KH' },
            { name: 'Cameroon', code: 'CM' },
            { name: 'Canada', code: 'CA' },
            { name: 'Central African Republic', code: 'CF' },
            { name: 'Chad', code: 'TD' },
            { name: 'Chile', code: 'CL' },
            { name: 'China', code: 'CN' },
            { name: 'Colombia', code: 'CO' },
            { name: 'Comoros', code: 'KM' },
            { name: 'Congo (Congo-Brazzaville)', code: 'CG' },
            { name: 'Costa Rica', code: 'CR' },
            { name: 'Croatia', code: 'HR' },
            { name: 'Cuba', code: 'CU' },
            { name: 'Cyprus', code: 'CY' },
            { name: 'Czechia (Czech Republic)', code: 'CZ' },
            { name: 'Democratic Republic of the Congo', code: 'CD' },
            { name: 'Denmark', code: 'DK' },
            { name: 'Djibouti', code: 'DJ' },
            { name: 'Dominica', code: 'DM' },
            { name: 'Dominican Republic', code: 'DO' },
            { name: 'East Timor (Timor-Leste)', code: 'TL' },
            { name: 'Ecuador', code: 'EC' },
            { name: 'Egypt', code: 'EG' },
            { name: 'El Salvador', code: 'SV' },
            { name: 'Equatorial Guinea', code: 'GQ' },
            { name: 'Eritrea', code: 'ER' },
            { name: 'Estonia', code: 'EE' },
            { name: 'Eswatini (fmr. "Swaziland")', code: 'SZ' },
            { name: 'Ethiopia', code: 'ET' },
            { name: 'Fiji', code: 'FJ' },
            { name: 'Finland', code: 'FI' },
            { name: 'France', code: 'FR' },
            { name: 'Gabon', code: 'GA' },
            { name: 'Gambia', code: 'GM' },
            { name: 'Georgia', code: 'GE' },
            { name: 'Germany', code: 'DE' },
            { name: 'Ghana', code: 'GH' },
            { name: 'Greece', code: 'GR' },
            { name: 'Grenada', code: 'GD' },
            { name: 'Guatemala', code: 'GT' },
            { name: 'Guinea', code: 'GN' },
            { name: 'Guinea-Bissau', code: 'GW' },
            { name: 'Guyana', code: 'GY' },
            { name: 'Haiti', code: 'HT' },
            { name: 'Honduras', code: 'HN' },
            { name: 'Hungary', code: 'HU' },
            { name: 'Iceland', code: 'IS' },
            { name: 'India', code: 'IN' },
            { name: 'Indonesia', code: 'ID' },
            { name: 'Iran', code: 'IR' },
            { name: 'Iraq', code: 'IQ' },
            { name: 'Ireland', code: 'IE' },
            { name: 'Israel', code: 'IL' },
            { name: 'Italy', code: 'IT' },
            { name: 'Ivory Coast', code: 'CI' },
            { name: 'Jamaica', code: 'JM' },
            { name: 'Japan', code: 'JP' },
            { name: 'Jordan', code: 'JO' },
            { name: 'Kazakhstan', code: 'KZ' },
            { name: 'Kenya', code: 'KE' },
            { name: 'Kiribati', code: 'KI' },
            { name: 'Kosovo', code: 'XK' },
            { name: 'Kuwait', code: 'KW' },
            { name: 'Kyrgyzstan', code: 'KG' },
            { name: 'Laos', code: 'LA' },
            { name: 'Latvia', code: 'LV' },
            { name: 'Lebanon', code: 'LB' },
            { name: 'Lesotho', code: 'LS' },
            { name: 'Liberia', code: 'LR' },
            { name: 'Libya', code: 'LY' },
            { name: 'Liechtenstein', code: 'LI' },
            { name: 'Lithuania', code: 'LT' },
            { name: 'Luxembourg', code: 'LU' },
            { name: 'Madagascar', code: 'MG' },
            { name: 'Malawi', code: 'MW' },
            { name: 'Malaysia', code: 'MY' },
            { name: 'Maldives', code: 'MV' },
            { name: 'Mali', code: 'ML' },
            { name: 'Malta', code: 'MT' },
            { name: 'Marshall Islands', code: 'MH' },
            { name: 'Mauritania', code: 'MR' },
            { name: 'Mauritius', code: 'MU' },
            { name: 'Mexico', code: 'MX' },
            { name: 'Micronesia', code: 'FM' },
            { name: 'Moldova', code: 'MD' },
            { name: 'Monaco', code: 'MC' },
            { name: 'Mongolia', code: 'MN' },
            { name: 'Montenegro', code: 'ME' },
            { name: 'Morocco', code: 'MA' },
            { name: 'Mozambique', code: 'MZ' },
            { name: 'Myanmar (formerly Burma)', code: 'MM' },
            { name: 'Namibia', code: 'NA' },
            { name: 'Nauru', code: 'NR' },
            { name: 'Nepal', code: 'NP' },
            { name: 'Netherlands', code: 'NL' },
            { name: 'New Zealand', code: 'NZ' },
            { name: 'Nicaragua', code: 'NI' },
            { name: 'Niger', code: 'NE' },
            { name: 'Nigeria', code: 'NG' },
            { name: 'North Korea', code: 'KP' },
            { name: 'North Macedonia', code: 'MK' },
            { name: 'Norway', code: 'NO' },
            { name: 'Oman', code: 'OM' },
            { name: 'Pakistan', code: 'PK' },
            { name: 'Palau', code: 'PW' },
            { name: 'Palestine State', code: 'PS' },
            { name: 'Panama', code: 'PA' },
            { name: 'Papua New Guinea', code: 'PG' },
            { name: 'Paraguay', code: 'PY' },
            { name: 'Peru', code: 'PE' },
            { name: 'Philippines', code: 'PH' },
            { name: 'Poland', code: 'PL' },
            { name: 'Portugal', code: 'PT' },
            { name: 'Qatar', code: 'QA' },
            { name: 'Romania', code: 'RO' },
            { name: 'Russia', code: 'RU' },
            { name: 'Rwanda', code: 'RW' },
            { name: 'Saint Kitts and Nevis', code: 'KN' },
            { name: 'Saint Lucia', code: 'LC' },
            { name: 'Saint Vincent and the Grenadines', code: 'VC' },
            { name: 'Samoa', code: 'WS' },
            { name: 'San Marino', code: 'SM' },
            { name: 'Sao Tome and Principe', code: 'ST' },
            { name: 'Saudi Arabia', code: 'SA' },
            { name: 'Senegal', code: 'SN' },
            { name: 'Serbia', code: 'RS' },
            { name: 'Seychelles', code: 'SC' },
            { name: 'Sierra Leone', code: 'SL' },
            { name: 'Singapore', code: 'SG' },
            { name: 'Slovakia', code: 'SK' },
            { name: 'Slovenia', code: 'SI' },
            { name: 'Solomon Islands', code: 'SB' },
            { name: 'Somalia', code: 'SO' },
            { name: 'South Africa', code: 'ZA' },
            { name: 'South Korea', code: 'KR' },
            { name: 'South Sudan', code: 'SS' },
            { name: 'Spain', code: 'ES' },
            { name: 'Sri Lanka', code: 'LK' },
            { name: 'Sudan', code: 'SD' },
            { name: 'Suriname', code: 'SR' },
            { name: 'Sweden', code: 'SE' },
            { name: 'Switzerland', code: 'CH' },
            { name: 'Syria', code: 'SY' },
            { name: 'Taiwan', code: 'TW' },
            { name: 'Tajikistan', code: 'TJ' },
            { name: 'Tanzania', code: 'TZ' },
            { name: 'Thailand', code: 'TH' },
            { name: 'Togo', code: 'TG' },
            { name: 'Tonga', code: 'TO' },
            { name: 'Trinidad and Tobago', code: 'TT' },
            { name: 'Tunisia', code: 'TN' },
            { name: 'Turkey', code: 'TR' },
            { name: 'Turkmenistan', code: 'TM' },
            { name: 'Tuvalu', code: 'TV' },
            { name: 'Uganda', code: 'UG' },
            { name: 'Ukraine', code: 'UA' },
            { name: 'United Arab Emirates', code: 'AE' },
            { name: 'United Kingdom', code: 'GB' },
            { name: 'United States of America', code: 'US' },
            { name: 'Uruguay', code: 'UY' },
            { name: 'Uzbekistan', code: 'UZ' },
            { name: 'Vanuatu', code: 'VU' },
            { name: 'Vatican City', code: 'VA' },
            { name: 'Venezuela', code: 'VE' },
            { name: 'Vietnam', code: 'VN' },
            { name: 'Yemen', code: 'YE' },
            { name: 'Zambia', code: 'ZM' },
            { name: 'Zimbabwe', code: 'ZW' }
        ],
    },
    actions: {

        INDEX_COUNTRIES ({ commit }, payload) {
            return window.axios.get(`${window.axios.ZIP_API}/api/countries/list`, {
                headers: {
                    Authorization: auth,
                }
            })
                .then(res => {
                    commit('SET_COUNTRIES', res.data)
                    return res;
                })
                .catch(err => {
                    console.error('INDEX_COUNTRIES::', err);
                    return err;
                });
        },

        INDEX_STATES({ commit }, payload) {
        
            return window.axios.get(`${window.axios.ZIP_API}/api/states/list/${payload}`, {
                headers: {
                    Authorization: auth,
                }
            })
                .then(res => {
                    commit('SET_STATES', res.data)
                })
                .catch(err => {
                    console.error('[VUEX INDEX_STATES]', err);
                    return err;
                })
                .finally(() => commit('SET_COUNTRY_CODE', payload))
        },

        INDEX_CITIES({ commit }, payload) {
        
            return window.axios.get(`${window.axios.ZIP_API}/api/cities/list/${payload}`, {
                headers: {
                    Authorization: auth,
                }
            })
                .then(res => {
                    commit('SET_CITIES', res.data)
                })
                .catch(err => {
                    console.error('[VUEX INDEX_CITIES]', err);
                    return err;
                })
        },

        GET_LOCATION_BY_ZIP ({ commit, state }, payload) {
            if(!state.countryCode && !payload) {        
                console.error('should set country and zip')
            };

            return window.axios
                .get(`${window.axios.ZIP_API}/api/location/${state.countryCode ? state.countryCode: 'BR'}/${payload.zip}`,{
                    headers: {
                        Authorization: auth,
                    }
                })
                .then(res => {
                    const { data } = res;
                    
                    if(data) {
                        const location = data.data;
                        commit('PUSH_STATE', location.state)
                        commit('PUSH_CITY', location.city)
                        commit('SET_LOCATION', {
                            zip: location.zip,
                            address: location.address,
                            neighborhood: location.neighborhood,
                            city: location.city,
                            state: location.state,
                            code: location.code,
                            currency: location.currency,
                            iso: location.iso,
                            languages: location.languages,
                            phonecode: location.phonecode,
                            country: payload.country,
                        })
                    } 
                })
                .catch(err => {
                    commit('VALID_ZIP', false)
                    console.error('GET_LOCATION_BY_ZIP::', err);
                    throw new Error('Unable to fetch zip code');
                })
        }
    },
    mutations: {

        SET_COUNTRIES (state, { data }) {
            state.countries = data;
        },

        SET_COUNTRY_CODE (state, payload) {
            state.countryCode = payload
        },

        SET_STATES (state, payload) {
            state.states = payload.data.states
        },

        SET_CITIES (state, payload) {
            state.cities = payload.data.cities
        },

        PUSH_COUNTRY (state, payload) {

            const index = state.countries.indexOf(item => item.iso === payload.iso);
            if(index === -1) {
                state.countries.push(payload);
            }
        },

        VALID_ZIP (state, payload) {
            state.validZIP = payload
        },

        CLEAR_ZIP_CODE (state) {
            state.validZIP = true
        },

        PUSH_STATE (state, payload) {
            
            const index = state.states.indexOf(item => item === payload);
            if(index === -1) {
                state.states.push(payload);
            }
        },

        PUSH_CITY (state, payload) {

            const index = state.cities.indexOf(item => item === payload);
            if(index === -1) {
                state.cities.push(payload);
            }
        },

        SET_LOCATION (state, payload) {

            state.location = payload;
        }
    },
    getters: {
        
        LOADED_COUNTRIES (state) {
            return state.countries;
        },

        LOADED_STATES (state) {
            return state.states;
        },

        LOADED_CITIES (state) {
            return state.cities;
        },

        LOADED_LOCATION (state) {
            return state.location;
        },

        SELECTED_COUNTRY_CODE (state) {
            return state.countryCode
        },

        ZIP_STATUS(state) {
            return state.validZIP
        },

        STATIC_COUNTRIES (state) {
            return state.staticCountries;
        }
    }
}